<div class="j-dropdown">
    <div class="j-dropdown__label j-text-field" style="padding-bottom: 4px" (click)="onTriggerSurfaceClick($event)">
        <div class="j-dropdown__selected-option">
            <input
                class="custom-input"
                type="text"
                [(ngModel)]="searchText"
                (input)="onInputChange()"
                [placeholder]="data?.label ?? selectedOptionText"
                (focus)="onMultiInputFocus()"
            />
        </div>
        <div class="j-dropdown__chevron-icon">
            <span [ngClass]="!drop ? 'visible' : 'not-visible'">
                <app-icon ic="IcChevronDown" size="m" color="#000000"></app-icon>
            </span>
            <span [ngClass]="drop ? 'visible' : 'not-visible'">
                <app-icon ic="IcChevronUp" size="m" color="#000000"></app-icon>
            </span>
        </div>
    </div>

    <ng-container *ngIf="showSuggestions">
        <!-- Single-select: select one row -->
        <ul class="j-dropdown__list text-body-s" *ngIf="!isMultiSelect">
            <ng-container *ngIf="filteredSuggestions.length > 0; else noSuggestions">
                <li
                    class="j-dropdown__list-item"
                    *ngFor="let suggestion of filteredSuggestions; let i = index"
                    [ngClass]="drop ? 'visible' : 'not-visible'"
                    (click)="onSuggestionClick(suggestion)"
                >
                    {{ suggestion.label }}
                </li>
            </ng-container>
            <ng-template #noSuggestions>
                <div>No suggestions found.</div>
            </ng-template>
        </ul>

        <!-- Multi-select: typed filter + checkbox rows (integrated field, PDP multi channels) -->
        <ul class="j-dropdown__list text-body-s" *ngIf="isMultiSelect">
            <li
                *ngIf="multiPlaceholderRow && drop"
                class="j-dropdown__list-item j-dropdown__list-item--multiselect"
                [ngClass]="drop ? 'visible' : 'not-visible'"
                (click)="multiClearSelections($event)"
            >
                <span>{{ multiPlaceholderRow.label }}</span>
            </li>
            <ng-container *ngIf="filteredSuggestions.length > 0">
                <li
                    class="j-dropdown__list-item j-dropdown__list-item--multiselect"
                    *ngFor="let suggestion of filteredSuggestions"
                    [ngClass]="drop ? 'visible' : 'not-visible'"
                    (click)="toggleMultiSuggestion($event, suggestion)"
                >
                    <span>{{ suggestion.label }}</span>
                    <span *ngIf="multiRowChecked(suggestion.value)" style="float: right">
                        <app-icon ic="IcSuccessColored" size="s"></app-icon>
                    </span>
                </li>
            </ng-container>
            <div
                *ngIf="drop && searchText && searchText.length && filteredSuggestions.length === 0"
                class="ac-multi-no-hit text-body-s"
            >
                No suggestions found.
            </div>
        </ul>
    </ng-container>
</div>
